import { FileActionButton } from "../file-action/file-action-controls";
import * as XLSX from "xlsx";

interface RMSummarylog {
  rawMaterialName: string;
  inwardQuantity: number;
  outwardQuantity: number;
  adjustQuantity: number;
}

interface ExportProps {
  data: RMSummarylog[];
  disabled?: boolean;
}

const RawMaterialExportSummary = ({ data, disabled = false }: ExportProps) => {
  const handleExport = () => {
    console.log("📥 Export clicked!");
    console.log("Data to export:", data);
    console.log("Data length:", data?.length);

    if (!data || data.length === 0) {
      console.warn("⚠️ No data to export");
      alert("No data to export");
      return;
    }

    try {
      // Prepare data for export with proper formatting
      const exportData = data.map((item) => ({
        "Raw Material": item.rawMaterialName || "",
        "Inward": item.inwardQuantity || 0,
        "Outward": item.outwardQuantity || 0,
        "Adjust": item.adjustQuantity || 0,
      }));

      console.log("📋 Export data prepared:", exportData);

      // Create workbook and worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Summary");

      // Set column widths for better readability
      const columnWidths = [
        { wch: 25 }, // Raw Material
        { wch: 18 }, // Inward Quantity
        { wch: 18 }, // Outward Quantity
        { wch: 18 }, // Adjust Quantity
      ];
      worksheet["!cols"] = columnWidths;

      // Generate filename with current date
      const date = new Date();
      const dateString = date.toISOString().split("T")[0];
      const filename = `RawMaterial-Summary-${dateString}.xlsx`;

      console.log("💾 Writing file:", filename);

      // Write file
      XLSX.writeFile(workbook, filename);

      console.log("✅ Export successful! Records exported:", exportData.length);
    } catch (error) {
      console.error("❌ Export error:", error);
      alert(`Export failed: ${error}`);
    }
  };

  return (
    <FileActionButton action="export"
      label="Export"
      icon="pi pi-download"
      className="p-button-success"
      onClick={handleExport}
      disabled={disabled}
      tooltip="Export summary"
      tooltipOptions={{ position: "top" }}
    />
  );
};

export default RawMaterialExportSummary;
